import { DialogModule } from '@angular/cdk/dialog';

import {
  ChangeDetectionStrategy,
  Component,
  computed,
  inject,
  OnInit,
  Signal
} from '@angular/core';
import {
  ButtonComponent,
  PopoutButtonComponent,
  ToolkitApiService
} from '@jeppesen-foreflight/jmkw-toolkit';
import { ThemeInfo } from '@jeppesen-foreflight/jmkw-types';
import { ThemeRadiosPopoutComponent } from './theme-radios-popout/theme-radios-popout.component';

@Component({
  selector: 'jmkw-theme-button',
  standalone: true,
  imports: [PopoutButtonComponent, ButtonComponent, DialogModule],
  templateUrl: './theme-button.component.html',
  styleUrls: ['./theme-button.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ThemeButtonComponent implements OnInit {
  private readonly _api = inject(ToolkitApiService);
  iconName = 'icon-brush';
  componentRef = ThemeRadiosPopoutComponent;
  numberOfThemes: Signal<number> = computed(
    () => this._api.getThemeOptions()?.length || 0
  );
  tooltipText = 'Theme Options';
  toggleAutomationKey = 'theme-toggle-button';
  popoutAutomationKey = 'theme-popout-button';

  currentTheme?: ThemeInfo;

  get isDark(): boolean {
    return !!(
      this.currentTheme?.metadata &&
      Object.values(this.currentTheme?.metadata)
        .toString()
        .toLocaleLowerCase()
        .includes('dark')
    );
  }

  ngOnInit() {
    this.currentTheme = this._api.currentTheme()();
  }

  toggleTheme() {
    const currentThemeId = this._api.currentTheme()()?.id;
    this.currentTheme = this._api
      .getThemeOptions()
      ?.find((theme) => theme.id !== currentThemeId);

    if (this.currentTheme) {
      this._api.changeTheme(this.currentTheme.id);
    }
  }
}
